import React from 'react';
import { device, FONTS } from '../../constants';
import styled from 'styled-components';

interface ParsedTextProps {
  text: string;
}

export const ParsedBoldText: React.FC<ParsedTextProps> = ({ text }) => {
  const parseText = (input: string): React.ReactNode => {
    const boldSplit = input.split(/(\*\*.*?\*\*)/g);

    return boldSplit.flatMap((part, index) => {
      const isBold = part.startsWith('**') && part.endsWith('**');
      const content = isBold ? part.slice(2, -2) : part;

      const lines = content.split('/');
      return lines.flatMap((line, i) => {
        const element = isBold ? (
          <strong key={`${index}-${i}`}>{line}</strong>
        ) : (
          <span key={`${index}-${i}`}>{line}</span>
        );

        return i < lines.length - 1
          ? [element, <br key={`br-${index}-${i}`} />]
          : [element];
      });
    });
  };
  return <TextWrapper>{parseText(text)}</TextWrapper>;
};

const TextWrapper = styled.div`
  font-family: ${FONTS.SUBTITLE};
  font-size: 22px;
  line-height: 1.5;
  @media screen and ${device.lg} {
    font-size: 18px;
  }
  @media screen and ${device.md} {
    font-size: 14px;
  }
`;
